import { PageView, ManageView,RouteView} from '@/layouts'
import SideRouter from './modules/sideRouter'

//基础页面
export const constantRouterMap = [
  {
    path: '/',
    component: PageView,
    meta: { title: '模来模往' },
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/defaultPage/Home.vue'),
        meta: { title: '模来模往' }
      },
      {
        path: 'search',
        name: 'Search',
        component: () => import('@/views/defaultPage/Search.vue'),
        meta: { title: '搜索工厂' }
      },
      {
        path: 'enquiry',
        name: 'Enquiry',
        component: () => import('@/views/defaultPage/Enquiry.vue'),
        meta: { title: '外协招标' }
      },
      {
        path: 'requireSquare',
        name: 'RequireSquare',
        component: () => import('@/views/defaultPage/RequireSquare.vue'),
        meta: { title: '发布需求' }
      },
      {
        path: 'setEnquiry',
        name: 'SetEnquiry',
        component: () => import('@/views/defaultPage/SetEnquiry.vue'),
        meta: { title: '招标广场' }
      },
      {
        path: 'demandSquare',
        name: 'DemandSquare',
        component: () => import('@/views/defaultPage/DemandSquare.vue'),
        meta: { title: '需求广场' }
      },
      {
        path: 'demandContent',
        name: 'DemandContent',
        component: () => import('@/views/defaultPage/DemandContent.vue'),
        meta: { title: '需求内容' }
      },
      {
        path: 'news',
        name: 'News',
        component: () => import('@/views/defaultPage/News.vue'),
        meta: { title: '资讯',keepAlive:true}
      },
      {
        path: 'NewsContent',
        name: 'NewsContent',
        component: () => import('@/views/defaultPage/NewsContent.vue'),
        meta: { title: '新闻内容' }
      },
      {
        path: 'ChooseFirm',
        name: 'ChooseFirm',
        component: () => import('@/views/defaultPage/ChooseFirm.vue'),
        meta: { title: '选择工厂' }
      },
      {
        path: 'FactoryInfo',
        name: 'FactoryInfo',
        component: () => import('@/views/defaultPage/FactoryInfo.vue'),
        meta: { title: '工厂详情' }
      },
      {
        path: 'WxRegister',
        name: 'WxRegister',
        component: () => import('@/views/defaultPage/WxRegister.vue'),
        meta: { title: '完成小程序注册' }
      },
      {
        path:'dynamic',
        name:'Dynamic',
        component: () => import('@/views/defaultPage/Dynamic.vue'),
        meta: { title: '动态'}
      },
      {
        path:'Exhibition',
        name:'Exhibition',
        component: () => import('@/views/defaultPage/Exhibition.vue'),
        meta: { title: '展会'}
      },
      {
        path:'ExhibitionContent',
        name:'ExhibitionContent',
        component: () => import('@/views/defaultPage/ExhibitionContent.vue'),
        meta: { title: '展会内容'}
      },
      {
        path:'Offer',
        name:'Offer',
        component: () => import('@/views/defaultPage/Offer.vue'),
        meta: { title: '报价'}
      },
      {
        path:'models',
        name:'Models',
        redirect: '/modelsIndex',
        component: RouteView,
        children: [
          {
            path:'modelsIndex',
            name:'ModelsIndex',
            component: () => import('@/views/defaultPage/Models/index.vue'),
            meta: { title: '模型',keepAlive: false}
          },
          {
            path:'modelsPage',
            name:'ModelsPage',
            component: () => import('@/views/defaultPage/Models/page.vue'),
            meta: { title: '模型详情',keepAlive: false}
          },
          {
            path:'UploadMoulds',
            name:'UploadMoulds',
            component: () => import('@/views/defaultPage/Models/UploadMoulds.vue'),
            meta: { title: '上传报价老子云',keepAlive: false}
          },
          {
            path:'Everxyz',
            name:'Everxyz',
            component: () => import('@/views/defaultPage/Models/Everxyz.vue'),
            meta: { title: '上传报价',keepAlive: false}
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('../views/Signup.vue'),
    meta: { title: '注册' }
  },
]

//侧边栏目录
export const asyncRoutes = SideRouter